const getCtaLink = (state) => {
    return state.ctaLink;
};

const getCtaText = (state) => {
    return state.ctaText;
};

const getDetailsLink = (state) => {
    return state.detailsLink;
};

const getDetailsText = (state) => {
    return state.detailsText;
};

const getUserInput = (state) => {
    return state.userInput;
};

const getUserInputByKey = (state, getters) => {
    return (key) => getters.getUserInput[key];
};

const getUpdateCount = (state) => {
    return state.updateCount;
};

// TODO: refactor this action
const getTermsRange = (state, getters) => {
    const term = getters.getDataByKey('term');
    let { min: termMin, max: termMax, values } = term;
    let range = {
        min: termMin,
        max: termMax,
    };
    let snap = true;

    // TODO: refactor this part
    if (range.min === range.max) {
        range.min = 0;
    }

    // in case we have term not in months
    if (state.isTermInDays || !values[0].termMinInMonths) {
        values.forEach((term, idx) => {
            const percentStep = parseInt(100 / values.length);
            const termMinToNumber = parseInt(term.min);
            const termMaxToNumber = parseInt(term.max);

            if (termMinToNumber !== termMin) {
                range[`${percentStep * idx}%`] = termMinToNumber;
            } else {
                range.min = termMinToNumber;
            }

            if (termMaxToNumber === termMax) {
                range.max = termMaxToNumber;
            }
        });

        values = values.map((term) => term.min);
        values.push(termMax);
        snap = false;
    } else {
        values.forEach((term, idx) => {
            const percentStep = parseInt(100 / (values.length - 1));
            const termToNumber = parseInt(term.termMinInMonths);

            if (termToNumber !== termMin && termToNumber !== termMax) {
                range[`${percentStep * idx}%`] = termToNumber;
            }
        });
    }

    return {
        ...(values.length > 1 ? { steps: 10 } : {}),
        range,
        ...(values.length > 1
            ? {
                  pips: {
                      mode: 'steps',
                      values: [...values],
                  },
              }
            : {
                  start: range.max,
              }),
        snap,
    };
};

const getAmountRange = (state, getters) => {
    let amount = getters.getDataByKey('amount');
    // TODO: refactor this
    if (amount.min === amount.max) {
        amount.min = 0;
    }

    const getRange = (stepValuableDigits = 3) => {
        let digitsMin = amount.min.toString().length - 1;
        let digitsMax = amount.max.toString().length;
        let baseStepDigits = digitsMin - stepValuableDigits + 1;
        let percentStep = Math.round(digitsMax > digitsMin ? 100 / (digitsMax - digitsMin) : 100);
        let percentage = 0;

        let range = {
            min: [amount.min, 5 * Math.pow(10, baseStepDigits)],
            max: [amount.max],
        };

        for (let i = 1; i < digitsMax - digitsMin; i++) {
            percentage += percentStep;
            range[`${percentage}%`] = [Math.pow(10, digitsMin + i), 5 * Math.pow(10, baseStepDigits + i)];
        }

        return range;
    };

    return {
        range: getRange(),
        pips: {
            mode: 'positions',
            values: [0, 100],
        },
    };
};

export {
    getCtaText,
    getCtaLink,
    getDetailsLink,
    getDetailsText,
    getUserInput,
    getUserInputByKey,
    getUpdateCount,
    getTermsRange,
    getAmountRange,
};
